import { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import styled from "styled-components";

const Options = styled.ul`
    position: absolute;
    top: 0;
    left: 0;
    margin-left: 0;
    transform: translateY(46px);
    width: 100%;
    background-color: #fff;
    z-index: 10;
    border: 0.0625rem solid rgba(231, 234, 243, 0.7);
    border-radius: 0.3125rem;
    max-height: 300px;
    overflow: auto;
    li {
        border: none;
        &:hover {
            border: none;
            background-color: rgba(231, 234, 243, 0.3);
        }
    }
`
export default function SelectBox({data, defaultValue = "", ...props}) {
    const [showOptions, setShowOptions] = useState(false);
    const [selectValue, setSelectValue] = useState(props.value ? props.value : defaultValue);
    const selectBoxRef = useRef();

    useEffect(() => {
        const handleClickDocument = (e) => {
            e.stopPropagation();
            if (selectBoxRef.current) {
                if (!selectBoxRef.current.contains(e.target)) {
                    setShowOptions(false);
                }
            }
        }

        data.map(el => {
            if (el.value == defaultValue) {
                setSelectValue(el.label);
            }
        });

        document.addEventListener("click", handleClickDocument);

        return () => {
            document.removeEventListener("click",handleClickDocument);
        }
    },[]);

    useEffect(() => {
        data.map((el) => {
            if (props.value == el.value) {
                setSelectValue(el.label);
            }
        })
    },[props.value])

    return (
        <div ref={selectBoxRef} className="position-relative" style={props.style}>

            <Form.Control 
                className="form-select bg-white"
                onClick={() => {
                    setShowOptions(true);
                }} 
                placeholder={props.placeholder}
                value={selectValue}
                readOnly 
            />
            {
            showOptions &&
            <Options className="custom-scroll">
                {
                    data.map((el) => {
                        return (
                        <li key={el.value} 
                            className="form-control"
                            onClick={(e) => {
                                setSelectValue(el.label);
                                setShowOptions(false);
                                if (props.onChange) {
                                    props.onChange(el);
                                }
                            }}
                        >{el.label}</li>
                    )
                    })
                }
            </Options>
            }
        </div>
    )
}